module.exports = __webpack_public_path__ + "media/land_blank.d222b8a4.svg";